import angular from 'angular';
import common from './core.module';
import ReportsDailyController from './controllers/reports/daily.controller';
import ReportsDashboardController from './controllers/reports/dashboard.controller';
import ReportsController from './controllers/reports/reports.controller';
import ReportsChartService from './services/report-chart-service';


const moduleName = 'atc-report';
angular.module(moduleName, [common])
    .controller("ReportsDailyController", ReportsDailyController)
    .controller('ReportsDashboardController', ReportsDashboardController)
    .controller('ReportsController', ReportsController)
    .service('ReportsChartService', ReportsChartService)
;


export default moduleName;
